/** Textos dos cartões da home por grupo de menu. */
const PROFILE_HOME_GROUP_DESCRIPTIONS: Record<string, string> = {
  'Recursos Humanos':
    'Cadastro unificado de pessoas, funções e cargos do quadro institucional.',
  'Locais de Atuação':
    'Gestão de vínculos, lotações e consulta de tabelas de atuação.',
  'Férias e eventos':
    'Gestão de férias, abonos, faltas, licenças, afastamentos e eventos de pessoal.',
  Atividades:
    'Painel, cadastro, pesquisa e relatórios das atividades dos defensores.',
  'Cadastro de Relatórios':
    'Criação, aprovação e tramitação dos relatórios mensais de atividades.',
  'Gestão de Estágios':
    'Frequências, pendências e processos seletivos.',
  Organizacionais:
    'Cadastro da estrutura organizacional: diretorias, defensorias, núcleos e setores.',
  Locais: 'Cadastro de comarcas, distritos, fóruns e unidades de atuação.',
  Escritório: 'Registro de gastos e categorias do escritório.',
  Estagiários:
    'Emissão e acompanhamento das folhas de frequência dos estagiários.',
  Utilitários:
    'Ferramentas e utilitários',
};

export function resolveProfileHomeGroupDescription(label: string): string {
  return (
    PROFILE_HOME_GROUP_DESCRIPTIONS[label] ??
    `Acesse ${label} nesta área do sistema.`
  );
}
